import { Flex } from '@tremor/react';
import s from '@/pages/ConnectorInfo/ConnectorInfo.module.scss';
import { useConnectorAuth } from '@/hooks/useConnectorAuth';
import { ConnectorTitle } from '../ConnectorTitle/ConnectorTitle';
import { ConnectionSteps } from '@/components/ConnectionSteps/ConnectionSteps';
import { FACEBOOK_CONNECTION_STEPS } from '@/utils/constants';
import { ConnectorSubtitle } from '../ConnectorSubtitle/ConnectorSubtitle';
import { ConnectorRadioButton } from '../../Inputs/ConnectorRadioButton/ConnectorRadioButton';
import { BottomActions } from '../BottomActions/BottomActions';

const defaultValChecked = 'user-token';
export function LinkedinInfoConnector() {
  const [setSelectedMethod, , isLoading, generateOAuthLink] = useConnectorAuth(
    defaultValChecked,
    {
      platform: 'linkedin-ads',
      OAuthUrl: 'https://www.linkedin.com/oauth/v2/authorization',
      clientID: import.meta.env._VITE_LINKEDIN_APP_ID,
    },
    'response_type=code',
  );

  return (
    <form
      className={s.form}
      onSubmit={async (e) => {
        e.preventDefault();
        const link = await generateOAuthLink(
          'r_organization_admin r_basicprofile r_ads r_ads_reporting',
        );
        window.location.href = link;
      }}
    >
      <ConnectorTitle connectorId="linkedin-ads">Linkedin</ConnectorTitle>
      <ConnectionSteps
        style={{ marginBottom: '40px' }}
        steps={FACEBOOK_CONNECTION_STEPS}
        currentStep={1}
      />
      <ConnectorSubtitle>Choose how to connect with Linkedin</ConnectorSubtitle>
      <Flex
        flexDirection="col"
        style={{ gap: '20px' }}
        onChange={(e) => setSelectedMethod((e.target as HTMLInputElement).value)}
      >
        <ConnectorRadioButton
          value="user-token"
          name="connector"
          label="Performance data access"
          defaultChecked
          description="Connect your historical performance data to fuel your reports"
        />
        <BottomActions isCreating={true} isLoading={isLoading} />
      </Flex>
    </form>
  );
}
